import { PlayCircle } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

const VIDEOS = [
  { tag: "Demand Planning", title: "Statistical forecasting in 12 minutes", len: "12:04" },
  { tag: "S&OP", title: "Running a pre-S&OP reconciliation", len: "09:31" },
  { tag: "Inventory", title: "Safety stock, explained properly", len: "14:48" },
  { tag: "AI in SCM", title: "Demand sensing with external signals", len: "11:20" },
  { tag: "Supply Planning", title: "Capacity planning fundamentals", len: "16:02" },
  { tag: "Transformation", title: "Building a planning operating model", len: "18:55" },
];

export default function Videos() {
  return (
    <Layout>
      <Seo
        title="Supply Chain Planning Videos | SCMBrain"
        description="Short, focused practitioner walkthroughs on demand planning, S&OP, inventory, supply planning, and AI in supply chain."
        path="/videos"
      />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">Videos</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B] max-w-2xl leading-tight">
          Practitioner walkthroughs you can actually use.
        </h1>
        <p className="mt-5 text-lg text-[#3E577A] max-w-2xl">Short, focused videos on the planning techniques that move the needle.</p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {VIDEOS.map((v, i) => (
            <div key={i} data-testid={`video-${i}`} className="group rounded-sm overflow-hidden border border-[#E5E7EB] bg-white hover:-translate-y-1 transition-transform">
              <div className="aspect-video bg-[#1B3A6B] flex items-center justify-center relative">
                <PlayCircle className="h-14 w-14 text-white/90 group-hover:scale-110 transition-transform" />
                <span className="absolute bottom-3 right-3 text-xs text-white bg-black/40 px-2 py-0.5 rounded-sm">{v.len}</span>
              </div>
              <div className="p-5">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#1A6B5A]">{v.tag}</span>
                <h3 className="font-heading font-bold text-[#1B3A6B] mt-2 leading-snug">{v.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
